export const load = () => ({
	title: 'Contractor Discount Program',
	showTitle: true,
});
